import React from 'react';
import { differentiators } from '../data/atlante';
export function DifferentiatorSection() {
  return <section className="bg-white px-4 py-5 sm:py-7" data-id="element-31" data-mp="3j4h21t7l4h6y">
      <div className="mx-auto max-w-5xl" data-id="element-32" data-mp="3j24hr9ectuqq">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-2xl" data-id="element-33" data-mp="3558yko4e2mwy">
          NON È SEMPLICEMENTE UN ALTRO EBOOK SULLA PROTESI DENTALE
        </h2>
        <p className="mt-1 text-center font-display text-sm font-extrabold uppercase tracking-wide text-gold sm:text-base" data-id="element-34" data-mp="3a5diko4i9zrx">
          È un sistema visivo completo per la consultazione professionale.
        </p>

        <div className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-35" data-mp="2mdy6w4qua640">
          {differentiators.map(item => <div key={item.title} className="flex gap-2" data-id="element-36" data-mp="2qerv6z871mxf">
              <span className="text-lg leading-none" aria-hidden="true" data-id="element-37" data-mp="2qd76hq8k8y7h">
                {item.emoji}
              </span>
              <div data-id="element-38" data-mp="2hfemw9vt34ea">
                <h3 className="text-[13.5px] leading-tight text-navy" data-id="element-39" data-mp="2hdtsqldelngy">
                  {item.title}
                </h3>
                <p className="text-[13px] font-medium leading-snug text-slate2" data-id="element-40" data-mp="15fkvktjzk1am">
                  {item.body}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}